// extracted by mini-css-extract-plugin
module.exports = {"M":"social_M__1eEml","Social":"social_Social__2x9YT","Icon":"social_Icon__3RYAR"};